import React from "react";
import { cn } from "./cn";

/**
 * Bun filter pill: the "All · 421 / Mine / Stalled" row above tables and
 * boards. Active pill is ink; inactive is outlined and hovers to mist.
 * size="sm" keeps a 32px visual pill inside the 44px mobile tap target.
 */
export default function FilterPill({ active, onClick, className, children, size = "md" }) {
  const appearance = active
    ? "bg-bun-ink border-bun-ink text-bun-on-ink"
    : cn(
        "bg-transparent border-bun-line text-bun-slate",
        size === "sm" ? "group-hover:bg-bun-mist" : "hover:bg-bun-mist"
      );
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={!!active}
      className={cn(
        "inline-flex items-center gap-[6px] font-instrument text-bun-meta font-strong whitespace-nowrap",
        "min-h-11 sm:min-h-0 cursor-pointer",
        size === "sm" ? "group" : "px-3 py-1 rounded-full border",
        "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bun-blue",
        size !== "sm" && appearance,
        className
      )}
    >
      {size === "sm" ? (
        <span className={cn(
          "inline-flex min-h-8 items-center gap-[6px] px-3 py-1 rounded-full border",
          appearance
        )}>
          {children}
        </span>
      ) : children}
    </button>
  );
}
